export const GAME_DETAIL_SECTIONS = [
  { id: "overview", label: "Overview" },
  { id: "full-game-ou", label: "Full Game O/U" },
  { id: "f5-ou", label: "First 5 O/U" },
  { id: "run-environment-v2", label: "Run Environment V2" },
  { id: "moneyline", label: "Moneyline Prediction" },
  { id: "f5-details", label: "First 5 Innings Details" },
  { id: "pitchers", label: "Starting Pitchers" },
  { id: "offense", label: "Team Offense" },
  { id: "lineups", label: "Lineups" },
  { id: "bullpens", label: "Bullpens" },
  { id: "rest", label: "Rest & Schedule" },
  { id: "ballpark-weather", label: "Park & Weather" },
  { id: "league-context", label: "League Context" },
  { id: "recent-performance", label: "Recent Performance" },
  { id: "coverage", label: "Data Coverage" },
];

export const GameDetailNav = () => {
  return (
    <nav data-testid="game-detail-nav" className="sticky top-24 hidden flex-col gap-1 lg:flex">
      {GAME_DETAIL_SECTIONS.map((section) => (
        <a
          key={section.id}
          href={`#${section.id}`}
          data-testid={`game-nav-${section.id}`}
          className="rounded-md px-3 py-1.5 font-mono text-xs text-zinc-500 transition-colors hover:bg-white/5 hover:text-white"
        >
          {section.label}
        </a>
      ))}
    </nav>
  );
};
